import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './theme';

/**
 * Puts the theme in scope and applies Material UI's baseline reset.
 *
 * `enableColorScheme` lets the browser paint its own furniture — scrollbars,
 * form controls, the space behind the page — in the active scheme. Without it a
 * dark page keeps light scrollbars, which is the usual tell of a dark mode that
 * was added on top rather than designed in.
 *
 * Mounted once, above the router, so every screen and every portalled surface
 * (dialogs, menus, tooltips) resolves the same theme.
 */
export function AppThemeProvider({ children }) {
  return (
    <ThemeProvider theme={theme} defaultMode="system">
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
}
